module.exports = __webpack_public_path__ + "img/img_mall_zfq.4adf867d.png";